import { useContext } from 'react';
import { ThemeContext } from '@/contexts/ThemeContext';

/**
 * Hook to access theme context
 *
 * Returns:
 * - themeName: Current palette
 * - setThemeName: Change palette
 * - mode: Light/dark mode setting ('light', 'dark', 'system')
 * - setMode: Change mode
 * - systemTheme: Resolved system preference ('light' or 'dark')
 */
export function useCustomTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useCustomTheme must be used within CustomThemeProvider');
  }
  return context;
}
